// O período passou a ser compartilhado (também usado na Auditoria da Gestão de usuários).
export * from 'src/app/shared/period/period.util';
